// the IP addresses for Syla prod servers.
// requests from Syla backend originate from these IPs.
export const PRODUCTION_IPS = ["54.66.64.45", "3.106.173.30"];
